import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { NS } from '@/constants';

import DayBox from '@/components/common/calendar/DayBox';

import styles from './CustomCalendar.module.scss';

export const CustomCalendar = ({ dayNames, weekList = [], numberOfDisplayedWeeks, selectedDay, onClick }) => {
  const { t } = useTranslation(NS.CHECKOUT);

  const [displayedWeeks, setDisplayedWeeks] = useState(numberOfDisplayedWeeks || weekList?.length);

  return (
    <>
      <table className={styles.table} data-test-id="calendar">
        <thead>
          <tr className={styles.head} data-test-id="header">
            {dayNames?.map((day, key) => (
              <th key={key}>
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {weekList?.map((week, index) =>
            index < displayedWeeks && (
              <tr key={index} data-test-id="week">
                {week.map((day) =>
                  <td key={day.dayOfShipping}>
                    <DayBox day={day} selected={selectedDay} onClick={onClick} />
                  </td>
                )}
              </tr>
            )
          )}
        </tbody>
      </table>
      {displayedWeeks < weekList?.length && (
        <p
          data-test-id="see-more"
          className={styles['see-more']}
          onClick={() => setDisplayedWeeks(displayedWeeks + 1)}
        >
          {t('shipMode.topChrono.seeMoreDate')}
        </p>
      )}
    </>
  );
};

CustomCalendar.propTypes = {
  dayNames: PropTypes.array.isRequired,
  weekList: PropTypes.array.isRequired,
  numberOfDisplayedWeeks: PropTypes.number,
  selectedDay: PropTypes.string,
  onClick: PropTypes.func
};

export default CustomCalendar;
